import React from 'react'
import '../home/home.scss';
import HomeImage from '../../Assets/Images/home.png';
import LearningData from './LearningData/LearningData';
import MainService from './MainService/MainService';
import Experts from './ExpertsSection/Experts';
import WhyChoose from './WhyChoose/WhyChoose';
import Service from './Service/Service';
import WeDefeated from './WeDefeated/WeDefeated';
import Partners from './Partners/Partners';
import Contact from './Contact/Contact';
export default function Home() {
    return (
        <>
            <div className="home-banner" id="home-section">
                <div className="container">
                    <div className="grid">
                        <div className="grid-items">
                            <div className="banner-text">
                                <h3>AI helps your Business to grow faster</h3>
                                <h2>
                                    Artificial Intelligence helps you
                                    <span>Manage like A Pro</span>
                                </h2>
                                <p>
                                    We are building software, plateforms, web and mobile applications with artificial intelligence that helps companies grow faster. It’s 
                                    like having a CFO for your company -- but one that never sleeps, takes off weekends, and doesn’t ask for a paycheck.
                                </p>
                                <div className="learn-more-button">
                                    <button>Learn More</button>
                                </div>
                            </div>
                        </div>
                        <div className="grid-items">
                            <div className="home-images">
                                <img src={HomeImage} alt="HomeImage"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <>
                <LearningData/>
            </>
            <>
                <MainService/>
            </>
            {/* <>
                <Service/>
            </> */}
            <>
                <Experts/>
            </>
            {/* <>
                <WhyChoose/>
            </>
            <>
                <Service/>
            </>
            <>
                <WeDefeated/>
            </>
            <>
                <Partners/>
            </> */}
            <>
                <Partners/>
            </> 
            <>
                <WeDefeated/>
            </>
            
            <>
                <Contact/>
            </>
        </>
    )
}
